module.exports = __webpack_public_path__ + "static/group-786ec82c7f2e3652eff748b1ce41e4ba.jpg";